export const documentsQueryKeys = {
  all: ["documents"] as const,
  list: (workspaceId: string) => ["documents", "list", workspaceId] as const,
  search: (workspaceId: string, query: string) => ["documents", "search", workspaceId, query] as const,
  detail: (documentId: string) => ["documents", "detail", documentId] as const,
  versions: (documentId: string) => ["documents", "versions", documentId] as const,
  draft: (documentId: string) => ["documents", "draft", documentId] as const,
  editor: (documentId: string, mode: "view" | "edit") => ["documents", "editor", documentId, mode] as const,
  git: (documentId: string) => ["documents", "git", documentId] as const,
  outputs: (documentId: string) => ["documents", "outputs", documentId] as const,
  redactions: (documentId: string) => ["documents", "redactions", documentId] as const,
};
